import { useAppStore } from "@/global/store";
import { selectUser } from "@/global/store/data/user";
import {
  Box,
  Divider,
  Link,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from "@mui/material";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { TbShirtSport } from "react-icons/tb";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      " Click Continue and connect your Atlanta United account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Account Manager within 24 hours of redemption. Reach out to Live Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title: "How does the Atlanta United Flex program work?",
    description:
      "The Atlanta United program allows fans to select any seat to select regular season games. Simply log into your Atlanta United Account Manager and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description:
      "Event tickets are delivered directly within your Atlanta United Account Manager.",
  },
];

export function TermsAndCondition() {
  return (
    <>
      By registering you agree to receive SMS alerts regarding ticket delivery
      and agree to the{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"

        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}
